import { HoldingClass, Operation, Society, Transaction } from 'types';

type GetTransactionNominalValueProps = {
  holdingClass: HoldingClass | null;
  transaction: Transaction;
  operation?: Operation | null;
  society: Society;
};

/**
 * Returns the nominal value from the first available source in this priority order:
 * 1. Holding class nominal value
 * 2. Transaction nominal value
 * 3. Operation nominal value
 * 4. Society nominal value
 * 5. Default to 0 if none of the above are available
 *
 * Uses nullish coalescing (`??`) so `0` is not skipped.
 */
export const getTransactionNominalValue = ({
  holdingClass,
  transaction,
  operation,
  society,
}: GetTransactionNominalValueProps): number =>
  holdingClass?.nominalValue ??
  transaction?.nominalValue ??
  operation?.nominalValue ??
  society?.nominalValue ??
  0;
